export const environment = {
  apiUrl: 'https://api.new.the-carp-specialist.staging.novon.dev',
};
